module.exports = __webpack_public_path__ + "static/media/tcs.9e1c6bdb.png";